<div class="form-group" [class.has-error]="touched && required && !value">
  <label *ngIf="label" [for]="id || name" class="form-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
    <span *ngIf="emailVerificationOn" class="email-verified-indicator">
      <i class="fas fa-light check {{ emailVerified ? 'fa-circle-check' : 'fa-circle-exclamation' }} "></i></span>
  </label>

  <input [type]="type" [disabled]="disabled" [id]="id || name" [name]="name" [placeholder]="placeholder"
    [required]="required" [readonly]="readonly" [pattern]="pattern" [class]="'form-control ' + class" [value]="value"
    [attr.maxlength]="maxlength" [attr.minlength]="minlength" (input)="onInput($event)" (blur)="onBlur()"
    (focus)="onFocus()" />

  <div *ngIf="(touched || formControl?.touched) && formControl?.errors" class="error-message">
    <span *ngIf="formControl?.hasError('required')">This field is required.</span>
    <span *ngIf="formControl?.hasError('pattern')">Invalid format.</span>
    <span *ngIf="formControl?.hasError('minlength')">Too short.</span>
    <span *ngIf="formControl?.hasError('maxlength')">Too long.</span>
  </div>
</div>